export default __webpack_public_path__ + "static/media/0770BLEU.8481d762.pdf";